
import { Component } from 'react';
import ToDoModule from './ToDoModule';
import ToDoForm from '../forms/ToDoForm';
import { makeBEM } from '../global/utils';
import { LABELS } from '../global/constants';
import Icon from '../atoms/Icon';
import { FormReveal } from './Animations';
import { GeneralObserver } from './Observer';
import { SortableToDos } from './SortableToDos';
import { EditButtonIcon } from '../atoms/EditButtonIcon';

class ToDosModule extends Component {

    constructor(props) {
        super(props);

        this.state = {
            boardId: this.props.boardID,
            todos: [],
            controller: this.props.controller ? this.props.controller : false,
            showForm: false,
            orderEditMode: false,
        }
        this.observer = false;
        this.moduleName = 'todos';

        this.bindFunctions();
    }

    // Bind functions to instance
    bindFunctions() {
        this.reactFn = this.reactFn.bind(this);
        this.showFormBtnClick = this.showFormBtnClick.bind(this);
        this.discardForm = this.discardForm.bind(this);
        this.deleteToDo = this.deleteToDo.bind(this);
        this.toggleOrderEditMode = this.toggleOrderEditMode.bind(this);
    }

    componentDidMount() {
        this.initialSetup();
    }

    // Setup observer and subscribe to events from controller
    // Fetch data from controller
    initialSetup() {
        const ctrl = this.state.controller;
        this.observer = new GeneralObserver(this.reactFn);
        
        ctrl.addObserver(this.observer);
        ctrl.fetchData();

        this.setState({
            controller: ctrl,
        });
    }

    // Reacts to controller events
    // Sets controller and todos
    reactFn(event) {
        const ctrl = this.state.controller;
        const newData = ctrl.getTodos();

        this.setState({
            controller: ctrl,
            todos: newData,
        });
    }

    // 
    // Delete
    // 

    // Taks in id and calls controller delete fn
    deleteToDo(id=-1) {
		if ( id !== -1 ) {
            const ctrl = this.state.controller;
            ctrl.delete(id);
		}
    }

    // 
    // UI
    // 

    // Toggles ToDoForm visibility by negating showForm state
    toggleFormVisibility() {
        const formShown = this.state.showForm;

        this.setState({
            showForm: !formShown
        });
    }

    // Show form btn event handler
    // Calls toggleFormVisibility
    showFormBtnClick() {
        this.toggleFormVisibility();
    }

    // Discard form event handler
    // Calls toggleFormVisibility
    discardForm() {
        this.toggleFormVisibility();
    }

    // Toggles order edit mode
    toggleOrderEditMode() {
        const ctrl = this.state.controller;
        ctrl.toggleOrderMode();
        const orderEditMode = this.state.orderEditMode;

        this.setState({
            controller: ctrl,
            orderEditMode: !orderEditMode
        })
    }

    // Renders dummy content while reloading
    renderDummyContent() {
		return (
			<div>
                <div className="todo dummy">
                    <div className="todo__title-wrapper">
                        <h4 className="todo__title  shimmer"></h4>
                    </div>
                    <div className="todo-item dummy">
                        <div className="todo-item__wrapper">
                            <div className="todo-item__content-grid">
                                <div className="btn--toggle btn--toggle-icon todo-item__done-btn shimmer"></div>
                                <span className="todo-item__content shimmer"></span>
                            </div>
                        </div>
                    </div>
                    <div className="todo-item dummy">
                        <div className="todo-item__wrapper">
                            <div className="todo-item__content-grid">
                                <div className="btn--toggle btn--toggle-icon todo-item__done-btn shimmer"></div>
                                <span className="todo-item__content shimmer"></span>
                            </div>
                        </div>
                    </div>
                    <div className="todo-item dummy">
                        <div className="todo-item__wrapper">
                            <div className="todo-item__content-grid">
                                <div className="btn--toggle btn--toggle-icon todo-item__done-btn shimmer"></div>
                                <span className="todo-item__content shimmer"></span>
                            </div>
                        </div>
                    </div>
                </div>
                

                <div className="todo dummy">
                    <div className="todo__title-wrapper">
                        <h4 className="todo__title  shimmer"></h4>
                    </div>
                    <div className="todo-item dummy">
                        <div className="todo-item__wrapper">
                            <div className="todo-item__content-grid">
                                <div className="btn--toggle btn--toggle-icon todo-item__done-btn shimmer"></div>
                                <span className="todo-item__content shimmer"></span>
                            </div>
                        </div>
                    </div>
                    <div className="todo-item dummy">
                        <div className="todo-item__wrapper">
                            <div className="todo-item__content-grid">
                                <div className="btn--toggle btn--toggle-icon todo-item__done-btn shimmer"></div>
                                <span className="todo-item__content shimmer"></span>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
		);
	}

    // renderToDo(todo) {
    //     const ctrl = this.state.controller;
    //     const animate = todo.animate ? todo.animate : false
    //     const id = todo.getId();
    //     return (
    //         <ToDoModule 
    //             data={todo}
    //             parentController={ctrl}
    //             key={id}
    //             deleteAction={this.deleteToDo}
    //             animate={animate}
    //         />

    //     )
    // }

    render() {
        const ctrl = this.state.controller;
        if ( !ctrl ) {
			return false;
		}

        const reloading = this.props.reloading;
		const renderContent = !reloading;
		const showFormBtn = !reloading;

        const todos = ctrl.getTodos();
        const hasTodos = todos && todos.length > 0;

        const showForm = this.state.showForm;
        const showFormBtnClass = `btn--icon-and-text ${makeBEM(this.moduleName, 'show-form-btn')}`;

        const showOrderEditBtn = !reloading;
        const orderEditBtnClass = `btn btn--icon btn--no-border ${makeBEM(this.moduleName, 'order-edit-btn')}`;
        const orderEditMode = ctrl.getOrderMode();

        return (
                <div className={ this.moduleName }>
                    { reloading &&
						this.renderDummyContent()
					}

                    { 
                        hasTodos && renderContent &&
                        <SortableToDos
                            data={todos} 
                            controller={ctrl} 
                            deleteAction={this.deleteToDo}
                        />
                    }
                    
                    {
                        showFormBtn &&
                        <div className={`board__form-btn board__form-btn--three-cols ${this.moduleName}__board-btns`}>
                            <button
                                className={ showFormBtnClass }
                                onClick={ this.showFormBtnClick  }
                            >
                                <Icon name="plus" size="2"/>{ LABELS.newToDo } 
                            </button>

                            {
                                showOrderEditBtn && 
                                <button 
                                    className={orderEditBtnClass}
                                    onClick={ this.toggleOrderEditMode }
                                >
                                    <EditButtonIcon editMode={orderEditMode}/>
                                </button>
                            }
                        </div>
                    }

                    {
                        showForm &&
                        <FormReveal>
                            <ToDoForm 
                                boardId={this.state.boardId} 
                                discardForm={this.discardForm}
                                controller={ctrl}
                            />
                        </FormReveal>
                    }
                </div>
              
            
        );
    }
}

export default ToDosModule;